// Level math + catalog labels from docs/GAMIFICATION_V2.md. Pure functions.

export const FAN_LEVELS = [
  { name: "Listener", min: 0 },
  { name: "Supporter", min: 250 },
  { name: "Tastemaker", min: 1000 },
  { name: "Superfan", min: 3000 },
  { name: "Headliner", min: 8000 },
  { name: "Icon", min: 20000 },
];

export const ARTIST_LEVELS = [
  { name: "Emerging", min: 0 },
  { name: "Rising", min: 500 },
  { name: "Breakout", min: 2500 },
  { name: "Headliner", min: 10000 },
  { name: "Global", min: 40000 },
];

// { level, next, pointsToNext, pct } — next is null at the top level.
export function levelProgress(points, levels = FAN_LEVELS) {
  const value = Math.max(0, Number(points) || 0);
  let index = 0;
  for (let i = 0; i < levels.length; i++) {
    if (value >= levels[i].min) index = i;
  }
  const level = levels[index];
  const next = levels[index + 1] || null;
  if (!next) return { level, next: null, pointsToNext: 0, pct: 100 };
  const span = next.min - level.min;
  const into = value - level.min;
  return {
    level,
    next,
    pointsToNext: next.min - value,
    pct: span > 0 ? Math.min(100, Math.round((into / span) * 100)) : 100,
  };
}

// Backend may send a level as "Supporter" or { name, min }.
export function levelName(level) {
  if (!level) return "";
  if (typeof level === "string") return level;
  return level.name || level.title || level.key || "";
}

export const STATUS_LABELS = {
  top10Supporter: "Top 10 supporter",
  foundingFan: "Founding fan",
  earlyBeliever: "Early believer",
  topStreamer: "Top streamer",
  topTipper: "Top tipper",
  playlistCurator: "Playlist curator",
  jukeboxChampion: "Jukebox champion",
  streetTeam: "Street team",
  ambassador: "Ambassador",
};

export const STREAK_LABELS = {
  dailyListen: "Daily listening",
  weeklyLive: "Weekly live",
};

const sameId = (a, b) => a !== undefined && a !== null && String(a) === String(b);

// `/engagement/me` statuses come "per artist": either flat rows
// [{ artistId, status }] / [{ artistId, key }] or grouped [{ artistId, statuses: [] }].
// Returns the status keys the viewer holds for one artist.
export function statusesForArtist(statuses, artistId) {
  if (!Array.isArray(statuses) || !artistId) return [];
  const keys = [];
  for (const row of statuses) {
    if (!row) continue;
    if (typeof row === "string") continue;
    if (!sameId(row.artistId ?? row.artist?._id ?? row.artist, artistId)) continue;
    if (Array.isArray(row.statuses)) {
      for (const s of row.statuses) keys.push(typeof s === "string" ? s : s?.key || s?.status);
    } else {
      keys.push(row.status || row.key || row.kind);
    }
  }
  return keys.filter(Boolean);
}

// Streaks may be a map { dailyListen: {...} } or a list [{ kind, ... }].
export function streakList(streaks) {
  if (!streaks) return [];
  if (Array.isArray(streaks)) {
    return streaks.map((s) => ({ key: s.kind || s.key || s.type, ...s }));
  }
  return Object.keys(streaks).map((key) => ({ key, ...(streaks[key] || {}) }));
}
